<div class="header_area" [class.white-header]="auth.loggedIn">
  <div class="header_content">
    <div class="site_logo">
      <a
        routerlink="dashboard"
        aria-label="Family Central home"
        class="fc_brand"
        href="/user/dashboard"
        ><span aria-hidden="true" class="fc_brand_glyph"
          ><svg
            viewBox="0 0 64 60"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <path
              d="M 32 56 C 14 44 5 30 5 16 C 5 8 11 4 16 4 C 22 4 28 7 32 13 C 36 7 42 4 48 4 C 53 4 59 8 59 16 C 59 30 50 44 32 56 Z"
              class="fc_brand_shield"
            ></path>
            <path
              d="M 32 44 C 21 35 14 25 14 16 C 14 11 17 9 21 9 C 25 9 29 11 32 15 C 35 11 39 9 43 9 C 47 9 50 11 50 16 C 50 25 43 35 32 44 Z"
              class="fc_brand_heart"
            ></path></svg></span
        ><span class="fc_brand_mark"
          ><span class="fc_brand_line1">Family</span
          ><span class="fc_brand_line2">Central</span></span
        ></a
      >
      @if (auth.loggedIn) {
        <a (click)="auth.logout()">Logout</a>
      }
    </div>
  </div>
</div>
